import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticleCosaE from "../pages/article-cosa-e/page";
import ArticleComeFunziona from "../pages/article-come-funziona/page";
import ArticleItaobuySicuro from "../pages/article-itaobuy-sicuro/page";
import ArticleMiglioriProdotti from "../pages/article-migliori-prodotti/page";
import ArticleGuida from "../pages/article-guida/page";
import ArticleTrova from "../pages/article-trova/page";
import ArticleRischi from "../pages/article-rischi/page";
import ArticleVs from "../pages/article-vs/page";
import ArticleConsigli from "../pages/article-consigli/page";
import ArticleStrategie from "../pages/article-strategie/page";
import ArticleVerificare from "../pages/article-verificare/page";
import ArticleConfronto from "../pages/article-confronto/page";
import ArticleItaliano from "../pages/article-italiano/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/cos-e-itaobuy-spreadsheet",
    element: <ArticleCosaE />,
  },
  {
    path: "/come-funziona-itaobuy",
    element: <ArticleComeFunziona />,
  },
  {
    path: "/itaobuy-sicuro",
    element: <ArticleItaobuySicuro />,
  },
  {
    path: "/migliori-prodotti-itaobuy",
    element: <ArticleMiglioriProdotti />,
  },
  {
    path: "/itaobuy-spreadsheet-guida",
    element: <ArticleGuida />,
  },
  {
    path: "/trova-prodotti-itaobuy",
    element: <ArticleTrova />,
  },
  {
    path: "/itaobuy-rischi",
    element: <ArticleRischi />,
  },
  {
    path: "/itaobuy-vs-alternative",
    element: <ArticleVs />,
  },
  {
    path: "/itaobuy-consigli-avanzati",
    element: <ArticleConsigli />,
  },
  {
    path: "/strategie-ricerca-prodotti",
    element: <ArticleStrategie />,
  },
  {
    path: "/come-verificare-prodotti",
    element: <ArticleVerificare />,
  },
  {
    path: "/itaobuy-confronto",
    element: <ArticleConfronto />,
  },
  {
    path: "/itaobuy-spreadsheet-italiano",
    element: <ArticleItaliano />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;